import { Routes, Route } from 'react-router-dom';
import { CallbackPage, LoginPage, ProtectedRoute, SilentRenewPage } from '../auth';
import { Shell } from '../components/Shell';

export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/callback" element={<CallbackPage />} />
      <Route path="/silent-renew" element={<SilentRenewPage />} />

      {/* Protected shell — document routes render via useRoutes(shellRouteObjects) */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Shell />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
